export default {
  EMPLOYEE_RECORD: {
    ADMINISTRATIVE: 'Compléments RH', BANK: 'Coordonnées bancaires', MEDICAL: 'Suivi médical administratif',
    QUALIFICATIONS: 'Langues et habilitations', CV: 'CV du collaborateur', PAYROLL: 'Rémunération du collaborateur',
    TITLE: 'Civilité', OTHER_FIRST_NAMES: 'Autres prénoms', BIRTH_COUNTRY: 'Pays de naissance',
    SS_CENTER: 'Adresse du centre de sécurité sociale', CLASSIFICATION: 'Classification complémentaire',
    COEFFICIENT: 'Coefficient', POSITION: 'Position', SPOUSE_LAST_NAME: 'Nom du conjoint', SPOUSE_FIRST_NAME: 'Prénom du conjoint',
    AGE: 'Âge à la date du jour', BIRTH_DATE: 'Date de naissance', BIRTH_DEPARTMENT: 'Département de naissance',
    FAMILY: 'Famille', CHILDREN: 'Enfants renseignés', LEGACY_CHILD_COUNT: 'Nombre d’enfants historique',
    CHILDREN_INCOMPLETE: 'Les fiches détaillées ne remplacent pas le compteur historique.', GENDER: 'Genre', GENDER_OTHER: 'Autre', DEPENDENT: 'À charge',
    LEGACY_EMERGENCY: 'Contact d’urgence historique', EMERGENCY: 'Contacts administratifs complémentaires',
    INDEPENDENT_CONTACTS: 'Cette liste est indépendante du contact historique.', CONTACT_NAME: 'Nom du contact', PHONE: 'Téléphone',
    RELATION: 'Relation', ADDRESS: 'Adresse', PRIMARY: 'Principal', MAKE_PRIMARY: 'Définir comme principal',
    REPLACEMENT_REQUIRED: 'Choisissez le nouveau contact principal avant de supprimer celui-ci.',
    HOLDER: 'Titulaire du compte', IBAN: 'IBAN', BIC: 'BIC', BANK_ADDRESS: 'Domiciliation bancaire',
    BANK_NOTICE: 'Aucun paiement ni virement n’est effectué depuis cette fiche.', LANGUAGE: 'Langue', LEVEL: 'Niveau', NATIVE: 'Langue maternelle',
    CERTIFICATION: 'Habilitation', OBTAINED: 'Date d’obtention', EXPIRES: 'Date d’expiration',
    VISIT: 'Visite de santé au travail', VACCINATION: 'Vaccination - suivi administratif', MEDICAL_KIND: 'Type d’événement',
    APPOINTMENT: 'Date et heure du rendez-vous', TIMEZONE: 'Fuseau horaire : {{zone}}', OFFSET: 'Décalage horaire pour cette heure ambiguë',
    MEDICAL_CENTER: 'Centre médical', PROFESSIONAL: 'Professionnel', ADMIN_REASON: 'Motif administratif', RENEW_BEFORE: 'À renouveler avant le',
    NO_CLINICAL_DATA: 'Ne saisissez aucun diagnostic, résultat clinique ou commentaire médical.',
    EDUCATION: 'Formation initiale', EXPERIENCE: 'Expérience professionnelle antérieure', DIPLOMA: 'Diplôme renseigné', SCHOOL: 'Établissement',
    STUDY_END: 'Fin des études', MENTION: 'Mention', COMPANY: 'Société', JOB: 'Poste occupé', START: 'Début', END: 'Fin', DESCRIPTION: 'Description',
    NO_LINKED_CV: 'Aucun candidat CV n’est rattaché à ce collaborateur.', PAYROLL_TAB: 'Onglet de rémunération', MONTH_FROM: 'Du mois', MONTH_TO: 'Au mois',
    PAYROLL_COLUMN: 'Rubrique à représenter', PAYROLL_NO_MAPPING: 'Les rubriques affichées sont celles configurées dans votre entreprise.',
    EVOLUTION: 'Évolution sur la période chargée', ACCOUNT: 'Informations de compte', PASSWORD_DEFINED: 'Mot de passe défini',
    IDENTITY_INFO: 'Informations d’identité présentes', YES: 'Oui', NO: 'Non', NOT_RECORDED: 'Non renseigné', UNAVAILABLE: 'Donnée indisponible',
    LOADING: 'Chargement…', EMPTY: 'Aucun élément renseigné.', FORBIDDEN: 'Vous n’avez pas accès à cette rubrique.', LOAD_ERROR: 'Impossible de charger cette rubrique.',
    RETRY: 'Réessayer', ADD: 'Ajouter', EDIT: 'Modifier', DELETE: 'Supprimer', DELETE_CONFIRM: 'Confirmer la suppression de cet élément ?',
    SAVED: 'Modifications enregistrées.', SAVE_ERROR: 'La sauvegarde a échoué ; votre saisie est conservée.',
    CONFLICT: 'Cet élément a changé depuis son chargement. Consultez la version actuelle avant de remplacer votre saisie.',
    UNSAVED_TITLE: 'Modifications non enregistrées', UNSAVED_MESSAGE: 'Quitter cette rubrique sans enregistrer les modifications ?',
    STAY: 'Rester', LEAVE: 'Quitter sans enregistrer', SAVING: 'Sauvegarde en cours ; veuillez attendre.',
    COMMENTS: 'Commentaires administratifs', COMMENT: 'Commentaire', ADD_COMMENT: 'Ajouter un commentaire',
    IMMUTABLE_COMMENTS: 'Pour corriger un commentaire, ajoutez-en un nouveau.', HISTORY: 'Historique des ajouts', DATE_TIME: 'Date et heure', AUTHOR: 'Auteur',
    ACTION: 'Action', BEFORE: 'Avant', AFTER: 'Après', CREATED: 'Création', UPDATED: 'Modification', DELETED: 'Suppression', ADDED_COMMENT: 'Commentaire ajouté',
    FILTER_FROM: 'Depuis le', FILTER_TO: 'Jusqu’au', ALL_ACTIONS: 'Toutes les actions', REQUIRED: 'Ce champ est obligatoire.',
    MAX_LENGTH: 'Maximum {{max}} caractères.', INVALID_DATE: 'Date invalide ou incohérente.', INVALID_TIME: 'Date ou heure du rendez-vous invalide.',
    AMBIGUOUS_TIME: 'Précisez le décalage horaire pour cette heure.', INVALID_IBAN: 'IBAN invalide : pays, longueur ou clé de contrôle.', INVALID_BIC: 'BIC invalide.',
    INVALID_PHONE: 'Numéro de téléphone invalide.', SOURCE_ERROR: 'La source existante est indisponible ou incohérente.',
    TIMEOUT: 'Le délai de traitement est dépassé. Votre saisie est conservée.',
    APPLY_FILTERS: 'Appliquer les filtres', RELOAD_CURRENT: 'Consulter la version actuelle', USE_CURRENT: 'Remplacer ma saisie par la version actuelle',
    ALL: 'Tous', CURRENT_VERSION: 'Version actuelle', NEW_ENTRY: 'Nouvel élément', LOGIN: 'Identifiant de connexion', ROLE: 'Rôle', STATUS: 'Statut',
    CURRENT_NOT_ON_PAGE: 'Cet élément est absent de la page chargée (déplacé ou supprimé). Parcourez la liste pour le retrouver ; votre saisie est conservée.',
    INVALID_VALUE: 'Valeur invalide.',
    HISTORY_SUBTITLE: 'Les changements apportés aux contacts, en un coup d’œil.', HISTORY_FILTERS: 'Filtres',
    HISTORY_NEWEST: 'Plus récents d’abord', HISTORY_OLDEST: 'Plus anciens d’abord', HISTORY_RESET: 'Réinitialiser',
    HISTORY_NO_FIELD_CHANGES: 'Aucun changement de coordonnées enregistré.',
    HISTORY_GENERAL_SUBTITLE: 'Les activités enregistrées dans cette rubrique, en un coup d’œil.', HISTORY_NO_DETAILS: 'Aucun détail supplémentaire enregistré.',
  },
  ALERT: {
    MyAlerts: 'Mes Alertes',
    TYPE: 'Type',
    NOMEN: "Nom de l'entité",
  },
  COMM: {
    TYPE: 'Type',
    DESC: 'La description',
  },
  NOTE: {
    NOTE: 'NOTE',
    COMMENTAIRE: 'COMMENTAIRE',
  },
  STRATEGIE: {
    NOM: 'NOM STRATEGIE',
    NOMPARAMETRE: 'NOM PARAMETRÉ',
    EVENT: 'ÉVÉNEMENT',
    TXT: 'Les équipes Transverses auxquelles appartient le user: ',
  },
  CARD: {
    BTNACTIF: 'Actif',
    BTNDESACTIF: 'Désactivé',
    BTNALUMNI: 'Alumni',
    ACCOUNTSTATUS: 'Statut du compte',
    VALID: 'Actif',
    ENATT: "En attente d'inscription",
    TAUXCOMP: 'Taux de completion du profil',
    RDVTERMINE: 'Nombre de rendez-vous terminés',
    Email: 'Email',
    Fonction: 'Fonction',
    LISTJOURSTRAVAILLES: 'Liste de Jours Travaillés',
    LISTCONGE: 'Liste des congés',
    LISTPLANNING: 'List de planning de déplacement',
    LISTMANAGES: 'Liste des collaborateurs managés',
    LISTMANAGESREMUNERATION: 'Liste des collaborateurs managés - Module Rémunération',
    Presentation: 'Présentation',
    HISTORIQUERDV: 'Historique des rendez-vous',
    LISTCOMMENT: 'Liste des notes et commentaires',
    STRATEGIE: 'Les stratégies qui ciblent ce collaborateur',
    DISPO: 'Disponibilités renseignées',
    Communities: 'Communautés',
    Alertes: 'Alertes',
    FORMATIONS: 'Formations',
    COMPETENCES: 'Compétences',
    NOTES: 'Notes internes',
    ENTRETIENS: 'Entretiens',
    EDIT_PHOTO: 'Modifier la photo',
    CONTRACT_INTERNSHIP: 'Stage',
    CONTRACT_APPRENTICESHIP: 'Alternance',
    CONTRACT_EXTERNAL: 'Prestataire',
    ONBOARDING_TRACKING: "Suivi de l'onboarding et de l'offboarding",
    ALL_DOCUMENTS: 'Tous les documents',
    GROUP_EMPLOYEE_RECORD: 'Dossier collaborateur',
    GROUP_TIME_AND_ABSENCE: 'Temps et absences',
    GROUP_PERFORMANCE: 'Développement et performance',
    GROUP_MANAGEMENT: 'Management et rémunération',
    GROUP_RELATIONS: "Relations et vie d’entreprise",
    HR_INFO: 'Infos RH utiles',
    ALERTS_REMINDERS: 'Alertes et rappels',
    SUMMARY_LOADING: 'Chargement de la synthèse…',
    SUMMARY_ERROR: 'La synthèse est indisponible pour le moment.',
    NO_REMINDERS: 'Aucune alerte ou rappel à afficher.',
    SHOW_REMINDERS: 'Tout voir',
    HIDE_REMINDERS: 'Réduire',
    REMINDERS_LIMIT: '{{shown}} éléments affichés sur {{total}}',
    HIGH_POTENTIAL: 'Haut potentiel',
    SPECIAL_FOLLOW_UP: 'Suivi particulier',
    ONBOARDING_PAUSED: 'Onboarding en pause',
    ONBOARDING_ACTIVE: 'Onboarding en cours',
    ONBOARDING_DONE: 'Onboarding terminé',
    OFFBOARDING_PAUSED: 'Offboarding en pause',
    OFFBOARDING_ACTIVE: 'Offboarding en cours',
    OFFBOARDING_DONE: 'Offboarding terminé',
    ENTRY_DATE: "Date d’entrée",
    EXIT_DATE: 'Date de sortie',
    TENURE: 'Ancienneté',
    TENURE_DAYS: '{{count}} jours',
    TENURE_MONTH: '{{count}} mois',
    TENURE_MONTHS: '{{count}} mois',
    TRIAL_END: "Fin de période d’essai",
    NO_DUE_DATE: 'Sans échéance',
    MORE_PROFILE_INFO: 'Plus d’informations',
  },
  ENTRETIENS: {
    TITLE: 'Entretiens',
    SUBTITLE: 'Liste en lecture seule des entretiens qui concernent ce collaborateur.',
    LOADING: 'Chargement des entretiens...',
    FILTER_TYPE: "Type d'entretien",
    FILTER_STATUS: 'Statut',
    ALL_TYPES: 'Tous les types',
    ALL_STATUSES: 'Tous les statuts',
    INTERVIEWS_TITLE: 'Entretiens du collaborateur',
    INTERVIEWS_SUBTITLE: 'Entretiens où ce collaborateur est la personne évaluée.',
    CROSS_FEEDBACKS_TITLE: 'Feedbacks croisés',
    CROSS_FEEDBACKS_SUBTITLE: 'Feedbacks croisés qui concernent ce collaborateur.',
    EMPTY_INTERVIEWS: 'Aucun entretien trouvé pour ce collaborateur.',
    EMPTY_FILTERED: 'Aucun entretien ne correspond aux filtres sélectionnés.',
    EMPTY_CROSS_FEEDBACKS: 'Aucun feedback croisé trouvé pour ce collaborateur.',
    COL_TYPE: "Type d'entretien",
    COL_MANAGER: 'Responsable / contributeur',
    COL_CONTRIBUTOR: 'Contributeur',
    COL_DATE: 'Date',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    VIEW: 'Lire',
    COUNT: '{{count}} élément(s)',
    COUNT_FILTERED: '{{filtered}} / {{total}} entretien(s)',
    PREVIOUS: 'Précédent',
    NEXT: 'Suivant',
    LOAD_ERROR: 'Impossible de charger les entretiens du collaborateur.',
    OPEN_ERROR: "Impossible d'ouvrir cet entretien.",
    IMPORTED_PDF_NOT_FOUND: 'Le PDF importé est introuvable pour cet entretien.',
    IMPORTED_PDF_OPEN_ERROR: "Impossible d'ouvrir le PDF importé.",
  },
  USER_NOTES: {
    TITLE: 'Notes internes',
    SUBTITLE: 'Ajoutez des informations confidentielles visibles uniquement par les administrateurs',
    DRAG_DROP_HINT: 'Glissez-déposez des images dans la zone d’édition pour les inclure automatiquement',
    SAVE_SUCCESS: 'Note enregistrée avec succès',
    SAVE_ERROR: "Impossible d'enregistrer la note pour le moment",
    LOAD_ERROR: 'Impossible de charger la note',
    EMPTY_MESSAGE: 'Veuillez saisir un contenu avant de sauvegarder',
    VISIBLE_TO_MANAGERS: 'Autoriser les managers à voir cette note',
    NOT_ALLOWED: 'Cette note n’est pas disponible car les administrateurs n’ont pas autorisé son partage avec les managers.',
    READONLY_INFO: 'Les managers peuvent consulter la note uniquement si elle est partagée par un administrateur.',
  },
  USERDETAILS: {
    USER_NOTES: {
      TITLE: 'Notes internes',
      SUBTITLE: 'Ajoutez des informations confidentielles visibles uniquement par les administrateurs',
      DRAG_DROP_HINT: 'Glissez-déposez des images dans la zone d’édition pour les inclure automatiquement',
      SAVE_SUCCESS: 'Note enregistrée avec succès',
      SAVE_ERROR: "Impossible d'enregistrer la note pour le moment",
      LOAD_ERROR: 'Impossible de charger la note',
      EMPTY_MESSAGE: 'Veuillez saisir un contenu avant de sauvegarder',
      VISIBLE_TO_MANAGERS: 'Autoriser les managers à voir cette note',
      NOT_ALLOWED: 'Cette note n’est pas disponible car les administrateurs n’ont pas autorisé son partage avec les managers.',
      READONLY_INFO: 'Les managers peuvent consulter la note uniquement si elle est partagée par un administrateur.',
    },
  },
  COLLAB: {
    listeCollaborateursManages: 'Liste des collaborateurs managés',
    ajouterCollaborateur: 'Ajouter un collaborateur',
    aucunCollaborateurManage: 'Aucun collaborateur managé',
    aucunCollaborateurSansManager: 'Aucun collaborateur sans manager',
    photo: 'Photo',
    nom: 'Nom',
    prenom: 'Prénom',
    equipe: 'Équipe',
    service: 'Service',
    site: 'Site',
    btnSave: 'Enregistrer',
    CONFIRMATION_RETIRER_MANAGER: 'Êtes-vous sûr de vouloir retirer ce collaborateur de votre liste de personnes managées?',
    EDIT: {
      BTN_CANCEL: 'Annuler',
      dateAutorisationEmbauche: "Date d'autorisation d'embauche",
      dateAutorisationLicenciement: "Date d'autorisation de licenciement",
      dateAutorisationDemande: "Date de l'autorisation ou demande de l'autorisation",
      titre: 'Titre',
      titreAutorisation: "Titre d'autorisation",
      numeroOrdreTitre: "Numéro d'ordre du titre",
      dateDelivranceTitre: 'Date de délivrance du titre',
      dateExpirationTitre: "Date d'expiration du titre",
      ERROR_DATE_EXPIRATION_AFTER_DELIVRANCE:
        "La date d'expiration du titre doit être postérieure à la date de délivrance.",
    }
  },
}
